// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"75cb6a4d6fe04895","5284":"40b3ce0f53275c2d"}[chunkId] + ".css";
};